import { useEffect } from 'react';

const RedirectExternal = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

export default RedirectExternal;
